import { createContext } from "react"

const AccessPersonToVisitContext = createContext();

export default AccessPersonToVisitContext;